export default {
  customerLocations: [],
  customerLocation: undefined,
};
